module.exports = __webpack_public_path__ + "static/media/pitch2Banner.450f8dc6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/pitch2Banner.png
 ** module id = 634
 ** module chunks = 0
 **/